// wishListStyles.ts
import { Box, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";
import colors from "../../theme/Colours";

export const StyledImage = styled("img")(({ theme }) => ({
  width: "200px",
  height: "150px",
  objectFit: "contain",
  [theme.breakpoints.down("sm")]: {
    width: "120px",
    height: "90px",
  },
}));

export const MainContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: "#fff",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(1),
  boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
  flexDirection: "column",
  alignItems: "center",
  position: "relative",
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    alignItems: "center",
    gap: "24px",
    padding: "20px 32px",
    marginBottom: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  },
}));

export const OrderStyles = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: theme.spacing(2.5),
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

export const SpaceBetween = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontSize: "18px",
  fontWeight: 500,
  color: colors.buttonBGColor,
  maxWidth: "180px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  [theme.breakpoints.up("sm")]: {
    fontSize: "22px",
    maxWidth: "none",
  },
}));

export const Text = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontSize: "12px",
  fontWeight: 400,
  color: colors.buttonBGColor,
  [theme.breakpoints.up("sm")]: {
    fontSize: "14px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "16px",
  },
}));

export const PriceText = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "16px",
  color: colors.buttonBGColor,
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "24px",
  },
}));

export const DeleteIconWrapper = styled(Box)(({ theme }) => ({
  alignSelf: "flex-end",
  cursor: "pointer",
  width: "28px",
  height: "28px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: "8px",
  right: "8px",
  zIndex: 2,
  [theme.breakpoints.up("sm")]: {
    position: "static",
    width: "24px",
    height: "24px",
  },
}));

export const RightActions = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  flexGrow: 1,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    alignItems: "flex-end",
    width: "auto",
  },
}));

export const ActionRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    alignItems: "center",
    width: "auto",
  },
}));

export const CustomDrop = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "36px",
  [theme.breakpoints.up("sm")]: {
    height: "40px",
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  height: "36px",
  borderColor: colors.primaryButtonOrange,
  color: colors.primaryButtonOrange,
  borderRadius: "4px",
  fontFamily: "Poppins, sans-serif",
  padding: "0 8px",
  whiteSpace: "nowrap",
  minWidth: "80px",
  fontSize: "13px",
  "&:hover": {
    backgroundColor: colors.primaryButtonOrange,
    color: colors.background2,
  },
  "&.Mui-disabled": {
    borderColor: colors.primaryButtonOrangeDisabled,
    color: colors.primaryButtonOrangeDisabled,
  },
  [theme.breakpoints.up("sm")]: {
    height: "40px",
    padding: "0 16px",
    minWidth: "90px",
    fontSize: "16px",
  },
}));
